import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createBaggage,
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  addedBaggageTemplate,
  baggageToPay,
  defaultBoardingPassResult,
  defaultCheckInBaggagePolicies,
  defaultRegulatoryDetailsForDomesticRoute,
  journeys,
  noItemToPayError,
  paymentRecords,
  seatmap,
} from '../../mock/data';
import {
  authorization,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';
import {
  servicePDBGPDSTBIKECatalog,
  servicesResponsebag,
} from './common/services';

/**
 * OW 1Journey
 * 1ADT
 * Add/remove baggages
 */
export const ow1Journey1AdtAddBaggageFromATPCO: MockMap = {
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    }),
    createBaggage({
      template: addedBaggageTemplate,
      id: 1
    })
  ])
  ],
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeys[0], seatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  authorizeJourneyPaymentRecord: [createMockData(authorization)],
  confirmJourneyPaymentRecord: [createMockData(paymentRecords)],
  createJourneyPaymentRecord: [createMockData(paymentRecords)],
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError]),
    createMockData(baggageToPay),
    createMockData(undefined, [noItemToPayError]),
    createMockData(undefined, [noItemToPayError])
  ],
  getRegulatoryDetails: [createMockData(defaultRegulatoryDetailsForDomesticRoute)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  servicesCatalogueFromJourney: [createMockData(servicePDBGPDSTBIKECatalog)],
  addJourneyServices: [createMockData(servicesResponsebag),
    createMockData(servicesResponsebag)
  ]
};
